module.exports = __webpack_public_path__ + "static/img/comtop-one.f6ca543.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/comtop-one.png
// module id = OJQx
// module chunks = 0